import { clamp } from 'lodash';

export interface NotificationAudio {
  name: string;
  url: string;
  soundEnabled: boolean;
}

export const NotificationSounds: NotificationAudio[] = [
  {
    name: 'None',
    url: '',
    soundEnabled: false,
  },
  {
    name: 'Microwave',
    url: '/assets/sounds/microwave.mp3',
    soundEnabled: true,
  },
  {
    name: 'Orchestra Hit',
    url: '/assets/sounds/orchestra-hit.mp3',
    soundEnabled: true,
  },
  {
    name: 'Ka-ching',
    url: '/assets/sounds/ka-ching.mp3',
    soundEnabled: true,
  },
  {
    name: 'LMG (single)',
    url: '/assets/sounds/lmg.mp3',
    soundEnabled: true,
  },
  {
    name: 'LMG (auto)',
    url: '/assets/sounds/lmg-auto.mp3',
    soundEnabled: true,
  },
  {
    name: 'Klaxon',
    url: '/assets/sounds/klaxon.mp3',
    soundEnabled: true,
  },
  {
    name: 'Pork Markets',
    url: '/assets/sounds/pork-markets.mp3',
    soundEnabled: true,
  },
  {
    name: 'Friends (F)',
    url: '/assets/sounds/friends-1.mp3',
    soundEnabled: true,
  },
  {
    name: 'Friends (M)',
    url: '/assets/sounds/friends-2.mp3',
    soundEnabled: true,
  },
  {
    name: "You're Fired",
    url: '/assets/sounds/fired.mp3',
    soundEnabled: true,
  },
];

export const MIN_TIME_BETWEEN_SOUNDS = 50;

export class NotificationPlayer {
  lastPlayTime: number = 0;
  isPlaying: boolean = false;
  sound: HTMLAudioElement | undefined;

  static instance: NotificationPlayer;

  constructor() {
    if (NotificationPlayer.instance) return NotificationPlayer.instance;
    NotificationPlayer.instance = this;
  }

  playSound(url: string, force: boolean = false): boolean {
    const now = new Date().getTime();

    if (force && this.sound !== undefined) {
      this.sound.pause();
    } else if (this.isPlaying || now - this.lastPlayTime < MIN_TIME_BETWEEN_SOUNDS) {
      return false;
    }

    this.isPlaying = true;
    this.lastPlayTime = now;
    this.sound = new Audio(url);

    this.sound.addEventListener('canplay', () => {
      this.sound?.play();
    });

    this.sound.addEventListener('ended', () => {
      this.isPlaying = false;
      this.sound = undefined;
    });

    return false;
  }

  playSoundByIndex(idx: number, force: boolean = false): boolean {
    idx = clamp(idx, 0, NotificationSounds.length - 1);
    const toPlay = NotificationSounds[idx];
    if (!toPlay.soundEnabled) return false;
    return this.playSound(toPlay.url, force);
  }

  playSoundByName(name: string, force: boolean = false): boolean {
    const toPlay = NotificationSounds.find(s => s.name === name);
    if (toPlay) {
      if (!toPlay.soundEnabled) return false;
      return this.playSound(toPlay.url, force);
    }
    console.warn('Unable to find sound with name ', name);
    return false;
  }

  static get() {
    return new NotificationPlayer();
  }
}
